import { render, staticRenderFns } from "./CurrencyWorld.vue?vue&type=template&id=3871518e&"
import script from "./CurrencyWorld.vue?vue&type=script&lang=js&"
export * from "./CurrencyWorld.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyWorld.vue?vue&type=style&index=0&id=3871518e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports